import { Spinner } from "@/components/ui/Loader/Spinner";
import { FC } from "react";

interface ProcessingOverlayProps {
  label: string;
}

export const ProcessingOverlay: FC<ProcessingOverlayProps> = ({ label }) => {
  return (
    <div className="fixed inset-0 z-100 flex h-screen w-screen items-center justify-center bg-white/10 text-white backdrop-blur-xs">
      <div>
        <Spinner /> {label}
      </div>
    </div>
  );
};
